import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {LanguageEnum, LANGUAGE_STORAGE_KEY} from '../enums/language.enum';

@Injectable({
  providedIn: 'root'
})
export class TranslatorService {

  constructor(private readonly translateService: TranslateService) {
  }

  public defineUsedLanguage(): void {
    let storedLanguage = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (storedLanguage && this.isSupportedLanguage(storedLanguage)) {
      document.documentElement.setAttribute('lang', storedLanguage.split("-")[0]);
      this.translateService.use(storedLanguage);
      return;
    }

    const browserLang = navigator.language.split('-')[0];
    const appLanguage = this.getSupportedLanguage(browserLang);
    document.documentElement.setAttribute('lang', appLanguage.split("-")[0]);
    localStorage.setItem(LANGUAGE_STORAGE_KEY, appLanguage);
    this.translateService.use(appLanguage);
  }

  public switchLanguage(language: string): void {
    if (this.isSupportedLanguage(language)) {
      localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
      document.documentElement.setAttribute('lang', language.split("-")[0]);
      this.translateService.use(language);
    }
  }

  /**
   * Returns the AEM language key for the given enum language.
   * The AEM language key is the part before the hyphen.
   * For example, for "en-GB" it returns "en".
   * @param enumLanguage The language in LanguageEnum format.
   * @returns The AEM language key as a string.
   */
  public getAemLanguageKey(enumLanguage: LanguageEnum): string {
    return enumLanguage.split("-")[0];
  }

  private isSupportedLanguage(lang: string): boolean {
    return Object.values(LanguageEnum).includes(lang as LanguageEnum);
  }

  private getSupportedLanguage(browserLang: string): LanguageEnum {
    const defaultLang = LanguageEnum.EN;
    const matchingLang = Object.values(LanguageEnum).find(lang =>
      lang.toLowerCase().startsWith(browserLang.toLowerCase())
    );
    return matchingLang || defaultLang;
  }
}
